import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';
Vue.use(VueRouter);

import Login from '../pages/Login';
import Intro from '../pages/Intro';
import Dashboard from '../pages/Dashboard';
import NewDashboard from '../pages/NewDashboard';
import Locations from '../pages/Locations';
import Settings from '../pages/SettingsPage';
import Npos from '../pages/NposPage';
import Giving from '../pages/GivingStatisticsPage';
import PrivacyPolicy from '../pages/PrivacyPolicyPage';
import TermsOfService from '../pages/TermsOfServicePage';
import NpoSingle from '../pages/NpoSinglePage';
/*import NpoSignUp from "../components/NPO/NpoSignUp";
import RetailerSignUp from "../components/Retailer/RetailerSignUp";*/
import DeviceType from '../pages/DeviceType';
import Congratulations from '../pages/Congratulations';
import UserInfo from '../pages/UserProfile.vue';
import ItemDetails from '../pages/ItemDetails';
import AddLocation from '../pages/AddLocation.vue'

const routes = [
	{
		path: '/',
		redirect: '/login'
	},
	{
		path: '/device-selection',
		name: 'THRIVE | Initiatives',
		component: DeviceType,
		meta: { auth: 1 },
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: { auth: 2 },
		props: { token: false },
	},
	{
		path: '/intro', //change
		name: 'Intro',
		component: Intro,
		meta: { auth: 2 },
		props: { token: false },
	},
	{
		path: '/userInfo',
		name: 'User Info',
		component: UserInfo,
		meta: { auth: 2 },
	},
	{
		path: '/terms-of-service',
		name: 'Terms of Service',
		component: TermsOfService,
		meta: { auth: 2 },
	},
	{
		path: '/privacy-policy',
		name: 'Privacy Policy',
		component: PrivacyPolicy,
		meta: { auth: 2 },
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: NewDashboard,
		props: true,
		meta: { auth: 1 },
	},
	{
		path: '/locations',
		name: 'Locations',
		component: Locations,
		meta: { auth: 1 },
	},
	{
		path: '/item/:id',
		name: 'Item Details',
		component: ItemDetails,
		// meta: { auth: 1 },
	},
	// {
	//     path: "/partner/:id",
	//     name: "Retail Partner",
	//     component: Partner,
	//     meta: { auth: 1 },
	// },
	{
		path: '/settings',
		name: 'Settings',
		component: Settings,
		props: true,
		meta: { auth: 1 },
	},

	/*{
        path        : '/npo_sign_up',
        name        : 'NPO Sign up',
        component   : NpoSignUp,
        meta        : { auth: 2 }
    },*/
	/*{
        path        : '/retailer_sign_up',
        name        : 'Retailer Sign up',
        component   : RetailerSignUp,
        meta        : { auth: 2 }
    },*/
	{
		path: '/npos',
		name: 'Non-profit organizations',
		component: Npos,
		props: true,
		meta: { auth: 1 },
	},
	{
		path: '/npos/:id',
		name: 'Non-profit organization',
		component: NpoSingle,
		meta: { auth: 1 },
	},
	{
		path: '/giving',
		name: 'Giving',
		component: Giving,
		meta: { auth: 1 },
	},
	{
		path: '/congratulate',
		name: 'Congratulations',
		component: Congratulations,
		meta: { auth: 2 },
		props: { token: false },
	},
	{
		path: '/add-location',
		name: 'Add Location',
		component: AddLocation,
		props: true,
		meta: { auth: 1 },
	},
	{
		path: '*',
		name: 'Page not found',
		redirect: '/',
	},
];

const router = new VueRouter({
	base: process.env.BASE_URL,
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		// always scroll to top
		return {
			el: '#main',
			top: -10,
		};
	},
	routes,
});

router.beforeEach((to, from, next) => {
	if (store.state.user === null || Vue.prototype.$access(to)) {
		next();
	}
	var html = document.getElementsByTagName('html');
	if (to.path == '/') {
		html[0].style.overflow = 'hidden';
	} else {
		html[0].style.overflow = 'inherit';
	}
});

export default router;
